import CreationForm from '../common/form';

function CreateCreation() {
  return (
    <CreationForm />
  );
}

export default CreateCreation;
